<template>
    <div class="dashboard super-admin-shell">
        <Sidebar />
        <div class="page">
            <div class="content dashboard">
                <slot />
            </div>
            <footer class="super-admin-footer">
                Copyright © 2025 | Todos os direitos reservados
            </footer>
        </div>
    </div>
</template>

<script>
    import Sidebar from '@/components/Weflix/Sidebar-SuperAdmin.vue';
    import { applySuperAdminBranding } from '@/utils/superAdmin/branding';

    export default {
        name: 'SuperAdminShell',
        components: {
            Sidebar,
        },
        mounted() {
            applySuperAdminBranding();
        },
        activated() {
            applySuperAdminBranding();
        },
    };
</script>

<style>
    @import url('@/css/weflix/super-admin-shell.css');
</style>
